<typography-v2
  (click)="pollerService.hideUnsuccesfulLockMessage()"
  (clickOutside)="pollerService.hideUnsuccesfulLockMessage()"
  (clickOutsideShouldIgnoreFirstClick)="false"
  class="text-white"
  look="text"
>
  Unfortunately, this lead was taken by another agent
</typography-v2>
